<template>
    <listHappinessTipsComponent :category="category" />
</template>

<script>
import listHappinessTipsComponent from "@/views/happiness-tips/pages/list_happiness-tips/components/list_happiness_tips_component.vue";
export default {
    name: "listHappinessTipsPage",
    components: {
        listHappinessTipsComponent
    },
    props: {
        category: {
            type: Object,
            required: false
        }
    }
}
</script>

<style lang="css" scoped>
</style>
